import React, { useEffect } from 'react';

import { apiDeleteCampaign } from 'src/api/campaignsSetup';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { UiToast } from 'src/components/UI/toasts';
import { MyCampaignsListItemType } from 'src/models/Campaigns/MyCampaigns';
import { DonationPageListItemType } from 'src/models/DonationPage/List';
import { dispatchAnyRequestStart } from 'src/store/anyRequest/helpers';
import { useAnyRequest } from 'src/utils/hooks/useAnyRequest';
import { useTHelper } from 'src/utils/i18n';
import { PromiseReturnType } from 'src/utils/types';

const uniqueId = 'campaignListDeleteCampaign';

type Props = {
  item: MyCampaignsListItemType | DonationPageListItemType | null;
  hideModal: () => void;
  onSubmit: (ignorePageIndex?: boolean) => void;

  donationPage?: boolean;
};

export const MyCampaignsModalDelete: React.FC<Props> = ({ item, hideModal, onSubmit, donationPage }: Props) => {
  const tHelper = useTHelper(`${donationPage ? 'donationPageList' : 'myCampaigns'}.modals.delete`);

  const { loading, response } = useAnyRequest<PromiseReturnType<typeof apiDeleteCampaign>>(uniqueId);

  const entitySingularLower = item?.ProjectTerminology.Singular.toLowerCase() || '';

  useEffect(() => {
    if (response) {
      hideModal();

      onSubmit();

      UiToast.success(
        tHelper('deleted', {
          entitySingular: item?.ProjectTerminology.Singular || '',
        })
      );
    }
  }, [hideModal, item?.ProjectTerminology.Singular, onSubmit, response, tHelper]);

  return (
    <UiModal
      header={tHelper('header', { entitySingularLower })}
      successLoading={loading}
      onSuccess={() => {
        if (item) {
          dispatchAnyRequestStart({
            data: item.ID,
            apiFunction: apiDeleteCampaign,
            uniqueId,
          });
        }
      }}
      onHide={hideModal}
      successBtnText={tHelper('successBtnText', { entitySingularLower })}
    >
      {tHelper('body', { entitySingularLower })}
    </UiModal>
  );
};
